// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cover[data-v-37cfcc56]{position:relative}.cover img[data-v-37cfcc56]{z-index:-1}.cover--activate[data-v-37cfcc56],.cover img[data-v-37cfcc56]{width:.96rem;height:.96rem;border-radius:.2rem}.cover--activate[data-v-37cfcc56]{position:absolute;top:0;left:0;line-height:.96rem;color:#fff;font-size:.28rem;text-align:center;background:rgba(0,0,0,.8)}", ""]);
// Exports
module.exports = exports;
